import { Box, Button, Text } from "@chakra-ui/react";
import { SheetHeader } from "../../../components/SheetHeader/SheetHeader";

interface WaitlistOfferViewProps {
  gender: string;
  onJoinWaitlist: () => void;
}

export const WaitlistOfferView = ({
  gender,
  onJoinWaitlist,
}: WaitlistOfferViewProps) => (
  <Box display="flex" flexDirection="column" gap="16px">
    <SheetHeader
      title={`This event is full for ${gender === "man" ? "men" : "women"}`}
      subtitle="We often get cancellations — join the wait list and we'll email you the moment a spot opens."
    />
    <Box px="20px">
      <Text fontFamily="body" fontSize="14px" color="fg.default" lineHeight="1.55" m="0" mb="16px">
        Your details are saved. Joining the wait list is free.
      </Text>
      <Button onClick={onJoinWaitlist} size="2xl" w="100%">
        Join the Wait List
      </Button>
    </Box>
  </Box>
);
